'use strict';

class EditAddressController {
    /*@ngInject*/
    constructor ($scope, $mdDialog, orderStore, order, $q, utils) {
        "ngInject";
        _.extend(this, {
            $mdDialog: $mdDialog,
            $scope: $scope,
            orderStore: orderStore,
            order: order,
            $q: $q,
            utils: utils
        });

        this.order = _.cloneDeep(order);
        this.to = this.order.to_address;
        this.from = this.order.from_address;
    }

    hide () {
        this.$mdDialog.hide();
    }

    cancel () {
        this.$mdDialog.cancel();
    }

    checkIfValidForm() {
        const form = this.editAddressForm;

        // Set form as submitted
        form.$setSubmitted();

        return form.$valid;
    }

    change () {
        const isValidForm = this.checkIfValidForm();
        if (!isValidForm) {
            return false;
        }

        let deferred = this.getAddressDetailsFor([this.from.place_id, this.to.place_id])
            .then(
                (details) => {
                    _.forEach(details, (detail, index) => {
                        let keyToUpdate = index === 0 ? 'from_address' : 'to_address',
                            addressLocality = (index === 0 ? this.from.description : this.to.description) || this.order[keyToUpdate].name;
                        _.extend(
                            this.order[keyToUpdate],
                            this.getLatLongFrom(detail.details),
                            {place_id: detail.placeId},
                            {name: addressLocality}
                        );
                    });
                }
            ).then( (details) => {
                this.$mdDialog.hide(this);
            });
    }

    getLatLongFrom (placeDetails) {
        return {
            latitude: placeDetails.geometry.location.lat(),
            longitude: placeDetails.geometry.location.lng()
        }
    }

    getAddressDetailsFor (placeIds) {
        let requests = _.map(placeIds, (placeId) => {
            let request = this.$q.defer();
            piko.googlePlaceDetails.getDetails({placeId: placeId}, (details) =>
                request.resolve({details: details, placeId: placeId})
            );
            return request.promise;
        });

        return this.$q.all(requests);
    }


    setAddressDetails (details, toKey) {
        const keysToExtract = ['country', 'administrative_area_level_1', 'locality'];
        const addressComponents = _.pluck(details.address_components, 'types');
        let [country, area, locality] = [
            _.findIndex(addressComponents, (types) => _.contains(types, keysToExtract[0])),
            _.findIndex(addressComponents, (types) => _.contains(types, keysToExtract[1])),
            _.findIndex(addressComponents, (types) => _.contains(types, keysToExtract[2]))
        ];
        this[toKey] = {
            country: details.address_components[country].long_name,
            area: details.address_components[area].long_name,
            locality: details.address_components[locality].long_name
        };
    }

    findLocality (searchText) {
        if (_.isEmpty(searchText)) {
            return undefined;
        }
        let deferred = this.$q.defer();
        piko.googlePlaces.getPlacePredictions({
            input: searchText,
            componentRestrictions: {country: 'in'}
        }, function (data) {
            deferred.resolve(data);
        });
        return deferred.promise;
    }
}

export default EditAddressController;


// WEBPACK FOOTER //
// ./client/app/common/popup.component/EditAddressController.js